import React from 'react';

import ItemRow from './ItemRow';
import { INTEGRATION_STATUSES } from './constants';

import {
  IntegrationStatus,
  IntegrationType,
  ItemValue,
  onDeleteCallback,
  onEditCallback,
} from './types';

type Props = {
  integration: IntegrationType;
  isIntegrationAdmin: boolean;
  isLoadingActions: boolean;
  onDelete: onDeleteCallback;
  onEdit: onEditCallback;
  version: string;
};

function ItemVersionRow(props: Props) {
  const {
    integration: integrationBase,
    isIntegrationAdmin,
    isLoadingActions,
    onDelete,
    onEdit,
    version,
  } = props;

  // The "latest version" is always the public one (even if there's a higher number),
  // and there isn't more than one public/production, so this is a safe assumption to make
  const integration = {
    ...integrationBase,
    isBeta: false,
    isPublic: false,
    isPending: false,
  };

  const onChoose = (value: ItemValue) => {
    switch (value) {
      case 'edit':
        onEdit({ id: integration.id, title: integration.title, version });
        break;
      case 'delete':
        onDelete({ id: integration.id, version });
        break;
    }
  };

  return (
    <ItemRow
      integration={{
        ...integration,
        version,
        status: INTEGRATION_STATUSES.private as IntegrationStatus,
      }}
      isIntegrationAdmin={isIntegrationAdmin}
      isLoadingActions={isLoadingActions}
      isShowingVersions={true}
      isVersion={true}
      onChoose={onChoose}
    />
  );
}

export default ItemVersionRow;
